import { burgerMenuBreakpoint, Boldable, Icon, iconSizes, Link, PageHeaderProps } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"

import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { DisplayMode } from "shared/utils/paths"

type Links = PageHeaderProps["links"]

const usePageHeaderLinks = (selected: DisplayMode): Links => {
  const { t } = useTranslation()
  const { catalogNavigation } = useCatalogNavigation()
  const navigate = useNavigateNoUpdate()

  const buildLink = (to: string): Link => ({
    href: to,
    onClick: () => navigate(to),
  })

  return [
    {
      ...buildLink(catalogNavigation.editLastVisitedPath()),
      isActive: selected === "edit",
      testId: "edit-tab",
      content: (
        <LabelAndIcon>
          <Boldable isBold={selected === "edit"}>{t("header.display_mode.edit")}</Boldable>
          <StyledIcon code="edit" size={iconSizes._25} />
        </LabelAndIcon>
      ),
    },
    {
      ...buildLink(catalogNavigation.gridLastVisitedPath()),
      isActive: selected === "grid",
      testId: "grid-tab",
      content: (
        <LabelAndIcon>
          <Boldable isBold={selected === "grid"}>{t("header.display_mode.grid")}</Boldable>
          <StyledIcon code="grid_view" size={iconSizes._25} />
        </LabelAndIcon>
      ),
    },
    {
      ...buildLink(catalogNavigation.previewPath("all")),
      isActive: selected === "preview",
      testId: "preview-tab",
      content: (
        <LabelAndIcon>
          <Boldable isBold={selected === "preview"}>{t("header.display_mode.preview")}</Boldable>
          <StyledIcon code="visibility" size={iconSizes._25} />
        </LabelAndIcon>
      ),
    },
  ]
}

const LabelAndIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

const StyledIcon = styled(Icon)`
  @media (min-width: ${burgerMenuBreakpoint}) {
    font-size: ${iconSizes._20}px;
    order: -1;
  }
`

export default usePageHeaderLinks
